module.exports = __webpack_public_path__ + "static/media/intro.dc31c2d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/intro.jpg
// module id = 8
// module chunks = 0